/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHosportsIconLinkRowData } from './hosports-icon-link-row.data';
import { IHosportsIconLinkRowProps } from './hosports-icon-link-row.props.autogenerated';

export interface IHosportsIconLinkRowViewProps extends IHosportsIconLinkRowProps<IHosportsIconLinkRowData> {

}

/**
 *
 * HosportsIconLinkRow component
 * @extends {React.PureComponent<IHosportsIconLinkRowProps<IHosportsIconLinkRowData>>}
 */
class HosportsIconLinkRow extends React.PureComponent<IHosportsIconLinkRowProps<IHosportsIconLinkRowData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default HosportsIconLinkRow;
